module.exports = __webpack_public_path__ + "img/c00_buildingtechwheelbarrow_Normal_ua.0b710673.webp";